import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { SOCIAL_IMPACT } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const SocialImpact = () => {
  const { t } = useLang();
  return (
    <section data-testid="social-impact-section" className="relative overflow-hidden py-24 md:py-32 border-t border-white/5">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[30vw] w-[30vw] rounded-full bg-[#F59E0B]/10 blur-[130px] pointer-events-none" />
      <div className="relative mx-auto max-w-4xl px-6 md:px-12 text-center">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.28em] uppercase text-[#F59E0B]/80 flex items-center justify-center gap-3">
            <span className="inline-block h-px w-8 bg-[#F59E0B]/40" />
            {t(SOCIAL_IMPACT.eyebrow)}
            <span className="inline-block h-px w-8 bg-[#F59E0B]/40" />
          </span>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 text-4xl sm:text-5xl md:text-6xl tracking-tighter font-medium text-white text-balance leading-[1.05]">
            {t(SOCIAL_IMPACT.title)}
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 mx-auto max-w-2xl text-lg text-white/55 leading-relaxed">{t(SOCIAL_IMPACT.desc)}</p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-12 rounded-3xl border border-white/[0.07] bg-white/[0.02] p-8 md:p-10 text-left">
            <h3 className="text-2xl font-medium tracking-tight text-white">{SOCIAL_IMPACT.projectTitle}</h3>
            <p className="mt-4 text-white/55 leading-relaxed">{t(SOCIAL_IMPACT.projectText)}</p>
            <Link
              to="/ikke-alene"
              data-testid="social-impact-cta"
              className="group mt-7 inline-flex items-center gap-2 rounded-full border border-[#F59E0B]/40 bg-[#F59E0B]/10 px-6 py-3 text-sm font-medium text-[#fcd9a0] transition-all duration-300 hover:bg-[#F59E0B]/20 hover:text-white"
            >
              {t(SOCIAL_IMPACT.cta)}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
